<template>
    <div class="main">
        <div class="header-image">
            <div class="header-overlay"></div>
            <img src="/static/flightclubny.jpg" />
            <div class="home-text">
                <h1 class="title">My SNKR Collection</h1>
                <h2 class="tagline">your collection, everywhere</h2>
            </div>
        </div>
        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell text-center">
                    <h2>Latest releases</h2>
                </div>
                <div v-for="sneaker in sneakers" class="small-12 medium-6 large-4 cell">
                    <router-link :to="{ path: `/sneakers/${sneaker.brand}/${sneaker.slug}` }" class="card">
                        <img :src="sneaker.image_url" />
                        <div class="card-section">
                            <p class="lead">{{ sneaker.brand }}</p>
                            <p>{{ sneaker.model_name }}</p>
                            <!--<div class="grid-x card-info">-->
                            <!--<div class="small-5 small-offset-1">-->
                            <!--<p>{{ sneaker.release_date_pretty }}</p>-->
                            <!--</div>-->
                            <!--<div class="small-5 small-offset-1">-->
                            <!--<p v-if="sneaker.original_price != 'TBA'">€{{ sneaker.original_price }}</p>-->
                            <!--<p v-else>{{ sneaker.original_price }}</p>-->
                            <!--</div>-->
                            <!--</div>-->
                        </div>
                    </router-link>
                </div>
                <div class="small-12 cell text-center">
                    <h2>Popular brands</h2>
                </div>
                <div v-for="brand in brands" class="small-12 medium-6 large-4 cell sneaker-card">
                    <router-link :to="{ path: `/sneakers/${brand.name}` }" class="card">
                        <img :src="brand.hero_image_url" />
                        <div class="card-section">
                            <p class="lead">{{ brand.name }}</p>
                        </div>
                    </router-link>
                </div>
                <div class="small-12 cell text-center">
                    <router-link :to="{ path: `/sneakers` }" class="button primary">Go to all brands</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    data () {
        return {

        }
    },
    computed: {
        sneakers () {
            return this.$store.getters.loadedSneakers.slice(0, 6)
        },
        brands () {
            return this.$store.getters.loadedBrands.slice(0, 3)
        }
    }
}
</script>
<style scoped>
.header-image {
    position: relative; 
    margin: 10px auto 40px auto;
}

.header-image img {
    height: 50vh;
    width: 100%;
    object-fit: cover;
}

.home-text {
    min-width: 320px;
    text-align: center;
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
}

.home-text h1, .home-text h2 {
    text-shadow: 1px 1px 4px black; 
    margin: 0 auto;
}

.header-overlay {
    position: absolute;
    top: 0; bottom: 0;
    left: 0; right: 0;
    background-color: #0a0a0a;
    opacity: 0.4;
}

.sneaker-card .card {
    background-color: rgb(236, 236, 236)
}
</style>



// WEBPACK FOOTER //
// Home.vue?23f67c9a